import {
  Button,
  Checkbox,
  Dialog,
  Flexbox,
  Text,
  Spacer,
  Tag,
  TextAreaField,
  useToast
} from "@skf-internal/ui-components-react";
import { useState, useEffect, useMemo } from "react";
import { useAppDispatch } from "../../app/hooks";
import { createGlobalRoleTicket } from "./globalRolesAPI";
import {
  searchUserListByEmailAsync,
} from "../users/userSlice";
import { debounce } from "lodash";

export interface IAttachGlobalRoleProps {
  auth: any;
  role: string;
  callback: any;
}

export default function AssignBulkRole(props: IAttachGlobalRoleProps) {
  const { auth, role, callback } = props;
  const { addToast } = useToast();
  const [isOpen, setIsOpen] = useState(false);
  const [isResponseOpen, setIsResponseOpen] = useState(false);
  const [emailId, setEmailId] = useState<any>([]);
  const [emailNotFound, setEmailNotFound] = useState<any>([]);
  const [emailFound, setEmailFound] = useState<any>([]);
  const [userEmailFound, setuserEmailFound] = useState<any>([]);
  const [isDebounced, setIsDebounced] = useState(false);
  const dispatch = useAppDispatch();
  const [disable, setDisable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showField, setShowField] = useState(true);
  const [failedResponse, setFailedResponse] = useState<any>([]);
  const [successResponse, setSuccessResponse] = useState(0);
  const [showEmailField, setShowEmailField] = useState(false);
  const [descHint, setDescHint] = useState("50 e-mails");
  const [uniqueEmailCount, setUniqueEmailCount] = useState("50 e-mails");
  const [countEmail, setCountEmail] = useState(0);
  const [textFieldValue, setTextFieldValue] = useState("");
  const [holdEmailData, setHoldEmailData] = useState('');
  const [descError, setDescError] = useState<"error" | undefined>();
  const DEBOUNCE_DELAY = 2500;
  const [description, setDescription] = useState("");
  const [reason, setReason] = useState("");
  const [declineHint, setDeclineHint] = useState("");
  const [declineError, setDeclineError] = useState<"error" | undefined>(
    undefined
  );

  const activateCreateButton = () => {
    setDisable(
      (
        emailFound.length > 0 &&
        emailNotFound.length === 0 &&
        description.length > 0 &&
        !descError &&
        uniqueEmailCount !== "0 / 50 e-mails"
      )
    );
  };

  useEffect(() => {
    activateCreateButton();
  }, [emailFound, emailNotFound]);



  const setHint = (value: string) => {
    if (value != undefined && value != "") {
      setDeclineHint(value.length + " / 500 max");
      if (value.length > 500) {
        setDeclineError("error");
      } else {
        setDeclineError(undefined);
      }
    } else {
      setDeclineHint("500 max");
    }
    setDisable(declineError != undefined);
  };

  //logic to remove the email id from the user found list
  const removeUserFromEmailFound = (emailToRemove: string) => {
    const updatedEmails = userEmailFound.filter((item: string) => item !== emailToRemove);
    setuserEmailFound(updatedEmails);
    const updatedEmailFound = emailFound.filter((item: { username: string; }) => item.username !== emailToRemove);
    const holidngDataUpdate = holdEmailData.replace(emailToRemove, '');
    setEmailFound(updatedEmailFound);
    setHoldEmailData(holidngDataUpdate);
    const updatedCount = (countEmail !== 0) ? (countEmail - 1) : countEmail;
    (updatedCount >= 50) ? setDescError("error") : setDescError(undefined);
    setCountEmail(updatedCount);
    setUniqueEmailCount(updatedCount + " / 50 e-mails");
  };

  //logic to remove the email id from the user not found list
  const removeUserFromEmailNotFound = (emailToRemove: string) => {
    const updatedEmails = emailNotFound.filter((item: string) => item !== emailToRemove);
    const holidngDataUpdate = holdEmailData.replace(emailToRemove, '');
    setEmailNotFound(updatedEmails);
    setHoldEmailData(holidngDataUpdate);
    const updatedCount = (countEmail !== 0) ? (countEmail - 1) : countEmail;
    (updatedCount >= 50) ? setDescError("error") : setDescError(undefined);
    setCountEmail(updatedCount);
    setUniqueEmailCount(updatedCount + " / 50 e-mails");
  };

  const debouncedEmailChangeHandler = useMemo(
    () =>
      debounce(async (query: string[]) => {
        setLoading(true);
        try {
          const result =
            await dispatch(searchUserListByEmailAsync({ emails: query }));
          setEmailNotFound(result.payload.notFound);
          setEmailFound(result.payload.usersFound);
          (result.payload.usersFound.length !== 0 || result.payload.notFound.length !== 0) ? setShowEmailField(true) : setShowEmailField(false);
          setLoading(false);
          const userFound = result.payload.usersFound.map((item: { userName: any; }) => item.userName);
          setuserEmailFound(userFound);
          setDescHint("50 e-mails");
        }
        catch (error) {
          console.error("Error in thunk:", error);
        }
        setTextFieldValue("");
      }, DEBOUNCE_DELAY),
    []
  );

  const validationDisplay = () => {
    const userEmailNotFound = emailNotFound;
    const styleCount = (countEmail > 50) ? {color: "red"} : {color:"black"};
    return (
      <>
        <Spacer feSpacing="xs" />
        <Text>Validated e-mails</Text>
        <Spacer feSpacing="xs" />
        <div id="tagfield" onClick={() => setShowField(true)} style={{ width: '100%', height: 'auto', overflowY: 'auto' }}>
          {" "}
          {userEmailNotFound.map((item: string, index: any) => (
            <Tag
              feClosable={{
                onClick: () => removeUserFromEmailNotFound(item),
              }}
              feColor="red"
            >
              {item}
            </Tag>
          ))}
          {userEmailFound.map((item: string, index: any) => (
            <Tag
              feClosable={{
                onClick: () => removeUserFromEmailFound(item),
              }}
              feColor="green"
            >
              {item}
            </Tag>
          ))}
        </div>
        <span style={styleCount}>{uniqueEmailCount}</span>
      </>
    )
  }


  // Stop the invocation of the debounced function after unmounting
  useEffect(() => {
    return () => {
      debouncedEmailChangeHandler.cancel();
    };
  }, [debouncedEmailChangeHandler]);

  useEffect(() => {
    setShowField(true);
    setDescError(undefined);
    setDescription("");
    setReason("");
    setDeclineHint("");
    setDescHint("");
    setUniqueEmailCount("");
    setCountEmail(0);
    setTextFieldValue("");
    setHoldEmailData('');
    setSuccessResponse(0);
    setFailedResponse([]);
    setShowEmailField(false);
    activateCreateButton();
  }, [isOpen]);

  const handleUserEmailChange = (value: string[]) => {
    debouncedEmailChangeHandler(value);
    setIsDebounced(true);
  };

  const isButtonDisabled = () => {
    let res: boolean | undefined;
    res = true;
    if (disable) {
      res = false;
    }
    return res;
  };

  const emailValidation = (event: { target: { value: string; }; }) => {
    const text = event.target.value;
    setTextFieldValue(text);
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    //appending the latest text entered to the previous one after validating email id and copy paste
    const appendEmail = ((/\s|,|\n/.test(text) || emailRegex.test(text)) ? (holdEmailData + ' ' + text) : holdEmailData);
    setHoldEmailData(appendEmail);
    //to split the email ids based on comma, space or new line
    const splitText: string[] = appendEmail.split(/[\s,]+|\n/).filter(Boolean);
    //to keep only the email ids which matches email pattern
    const outputText: string[] = splitText.filter(email => emailRegex.test(email));
    //to remove the duplicate email ids and the one which matches domain part with shorter version
    const uniqueEmailIds = outputText.map((email) => {
      const [localPart, domain] = email.split('@');
      return { original: email, localPart, domain};
    })
    .reduce((acc: { localPart: string; domain: string; original: string }[], current) => {
      const currentIndex = acc.findIndex((email) => email.localPart === current.localPart);
      if(currentIndex === -1){
        acc.push(current);
      }
      else{
        const existEmail = acc[currentIndex];
        if(current.domain.length > existEmail.domain.length ){
          acc[currentIndex] = current;
        }
      }
      return acc;
    }, [])
    .map((email) => email.original);
    const userEmail = text.split(/[\s,]+|\n/).filter(Boolean);
    setEmailId(userEmail);
    let email_count = (!text ? 0 : userEmail.length);
    let uniqueEmailCount = (!text ? 0 : uniqueEmailIds.length);
    setCountEmail(uniqueEmailCount);
    setDescError(undefined);
    if (text !== undefined) {
      setUniqueEmailCount(uniqueEmailCount + " / 50 e-mails");
      setDescHint(email_count + " / 50 e-mails");
      if (email_count > 50) {
        setDescError("error");
      }
    } else {
      setDescHint("50 e-mails");
      setUniqueEmailCount("50 e-mails");
    }
    setDescription(text);
    handleUserEmailChange(uniqueEmailIds);
  };

  const assignRole = async () => {
    let results: any = [];
    let assignRolePromises: any = [];
    const promises = emailFound.map(async (data: any) => {
      try {
        assignRolePromises.push(createGlobalRoleTicket({
          userProfileId: data.id,
          globalRole: role,
          adminId: auth.idTokenClaims.sub,
          reason: reason,
        }))
      }
      catch (error) {
        console.log(error);
      }
    });
    results = Promise.allSettled(assignRolePromises).then(res => stepsAfterApiCall(res));
    // call back help to rerender the data after the operation
    callback();
    // this is to close the modal
    setIsOpen(false);
    setTimeout(() => {
      callback();
    }, 1000)
  };

  const stepsAfterApiCall = (response: any) => {
    let finalResponse = response.map((data: any, index: any) => {
      return (data?.status === "fulfilled" ? true : emailFound[index])
    })
    let successArray = finalResponse?.filter((data: any) => data === true);
    let failedArray = finalResponse?.filter((data: any) => data !== true);
    setSuccessResponse(successArray.length);
    if (successArray?.length === emailFound?.length) {
      setTimeout(() => {
        addToast({
          children: `Role assigned successfully to the ${successArray?.length} user(s)`,
          feSeverity: "success",
        });
      })
      callback();
    }
    if (failedArray?.length > 0) {
      let failedEmails = failedArray.map((data: { userName: any; }) => data.userName);
      setFailedResponse(failedEmails);
      setTimeout(() => {
        addToast({
          children: `The role is not assigned to the ${failedArray?.length} user(s)`,
          feSeverity: "error",
        });
      }, 0)
        //This is to close the status message modal box
      setIsResponseOpen(true);
    }
  }

  const resultMessageDisplay = () => {
    return (
      <>
        <Spacer feSpacing="sm" />
        {
          (failedResponse.length > 0 && successResponse === 0) ?
            <>
              <div style={{ padding: "1rem 0rem", height: "15rem", overflow: "auto" }}>
                <Spacer feSpacing="sm" />
                <Text as="b">The role could not be assigned to the following user(s):</Text>
                <Spacer feSpacing="sm" />
                <div >
                  <ol>
                    {failedResponse.map((email: any) => (
                      <>
                        <li key={email}>
                          {`${email}`}
                        </li>
                        <Spacer feSpacing="sm" />
                      </>
                    ))}
                  </ol>
                </div>
              </div>
            </>
            :
            <>
              <div style={{ padding: "1rem 0rem", height: "15rem", overflow: "auto" }}>
                <Spacer feSpacing="sm" />
                <Text as="b">Role is assigned to the {successResponse} user(s)</Text>
                <Spacer feSpacing="xs" />
                <Text as="b">The role could not be assigned to the following user(s):</Text>
                <Spacer feSpacing="sm" />
                <div>
                  <ol>
                    {failedResponse.map((email: any) => (
                      <>
                        <li key={email}>
                          {`${email}`}
                        </li>
                        <Spacer feSpacing="sm" />
                      </>
                    ))}
                  </ol>
                </div>
              </div>
            </>
        }
        <Spacer feSpacing="sm" />
        <Flexbox feGap="md" feJustifyContent="flex-end">
          <Button feType="secondary" onClick={() => {
            setIsResponseOpen(false)
            callback()
          }}>
            Close
          </Button>
        </Flexbox>
      </>
    )
  };

  return (
    <div style={{ padding: "12px 20px" }}>
      <Button onClick={() => setIsOpen(true)}>
        Bulk assign role
      </Button>
      <Dialog {...props} feInterruptive feTitle="Assign role to multiple users" open={isOpen || isResponseOpen}
        cssWidth={isOpen ? "54rem" : (isResponseOpen ? "30rem" : "0rem")}
        cssHeight={isOpen ? "36rem" : (isResponseOpen ? "30rem" : "0rem")}>
        {/* <Spacer feSpacing="sm" /> */}
        {isOpen && !isResponseOpen &&
          <>
            <div>
              <span>
                {/* You are currently assigning the role <b>{role}</b> to the users. */}
                Enter up to 50 e-mail addresses of users you want to assign the role <b>{role}</b> to.
              </span>
              <TextAreaField
                disabled={
                  (descError === "error" || countEmail >= 50)
                }
                feLabel="Separate each e-mail with a space or comma, or paste a list of e-mails."
                placeholder="Enter e-mail addresses here..."
                feHint={descHint}
                required
                feSeverity={descError}
                value={textFieldValue}
                onChange={(event: any) => {
                  emailValidation(event);
                  activateCreateButton();
                }}
              />
            </div>
            <Spacer feSpacing="sm" />
            <div>
              {showEmailField && validationDisplay()}
            </div>
            <Spacer feSpacing="sm" />
            <Checkbox
              disabled
              defaultChecked
              feLabel="The user will be notified about the new role."
              feSize="sm"
            />
            <Spacer feSpacing="md" />
            <TextAreaField
              feLabel="Personal message (optional)"
              feHint={declineHint}
              placeholder="Add a personal message to the user."
              feSeverity={declineError}
              onChange={(_, value) => {
                setReason(value);
                setHint(value);
                activateCreateButton();
              }}
              value={reason}
              className="AddRoleToUserTextField"
            />
            <Spacer feSpacing="sm" />
            <Flexbox feGap="md" feJustifyContent="flex-end">
              <Button feType="secondary" onClick={() => setIsOpen(false)}>
                Cancel
              </Button>
              <Button disabled={isButtonDisabled()} onClick={() => assignRole()}>
                Assign role
              </Button>
            </Flexbox>
          </>


        }
        {!isOpen && isResponseOpen && resultMessageDisplay()}
      </Dialog>

    </div>
  );
}
